import { Box, Select, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
export const StyledBoxWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
export const StyledBoxTab = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.tabColor,
  padding: "14.5px 16.5px",
  display: "flex",
  borderRadius: theme.borderRadius.radius.large,
  [theme.breakpoints.down("sm")]: {
    padding: "10.5px 10.5px",
    display: "flex",
    flexDirection: "column",
  },
}));
export const StyledTypographyEdit = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.extraLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.profileText,
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.regular.fontSize,
  },
}));
export const StyledTypographyUpdate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.profileTextUpdate,
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.base.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledTypographyTab = styled(Typography)(({ theme, value }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.profileTextUpdate,
  textAlign: "center",
  backgroundColor: value ? "white" : "transparent",
  padding: "14.5px 14.5px",
  borderRadius: theme.borderRadius.radius.medium,
  fontWeight: theme.typography.fontWeight.medium,
  flex: 1,
  cursor: "pointer",

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.mini.fontSize,
    padding: "10.5px 10.5px",
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
    padding: "10.5px 10.5px",
  },
}));
export const StyledBoxTabValue = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.orderCards,
  padding: "12px 18px",
  borderTopLeftRadius: theme.borderRadius.radius.large,
  borderTopRightRadius: theme.borderRadius.radius.large,
}));
export const StyledTypographyTabValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontWeight: theme.typography.fontWeight.semiBold,
  fontSize: theme.typography.large.fontSize,

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.small.fontSize,
  },
}));
export const StyledTypographyTabValueUpdate = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.custom.white,
    fontSize: theme.typography.regular.fontSize,

    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.small.fontSize,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.mini.fontSize,
    },
  })
);
export const StyledBoxPersonal = styled(Box)(({ theme, margin }) => ({
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
  marginTop: margin && "52px",
}));

export const StyledTypographyProfile = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.extraLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.profileText,

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.regular.fontSize,
  },
}));
export const StyledTypographyUpdateProfile = styled(Typography)(
  ({ theme }) => ({
    fontSize: theme.typography.base.fontSize,
    color: theme.palette.custom.profileTextUpdate,

    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.base.fontSize,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.mini.fontSize,
    },
  })
);
export const StyledTypographyInfo = styled(Box)(({ theme, fontWeight }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.textInfo,
  fontWeight: fontWeight && theme.typography.fontWeight.medium,
  display: "flex",
  alignItems: "center",
  gap: "8px",

  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledBoxInfo = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "18px",
  marginTop: "17px",
}));

export const StyledBoxPersonalAll = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  justifyContent: "space-between",  
}));

export const StyledBoxTabAll = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.tabColor,
  padding: "14.5px 16.5px",
  display: "flex",
  borderRadius: theme.borderRadius.radius.large,
  [theme.breakpoints.down("sm")]: {
    padding: "10.5px 10.5px",
  },
}));

export const StyledTypographyTabValueInform = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.custom.white,
    fontWeight: theme.typography.fontWeight.semiBold,
    fontSize: theme.typography.large.fontSize,
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.large.fontSize,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.regular.fontSize,
    },
  })
);
export const StyledTypographyTabValueUpdateInform = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.custom.white,
    fontSize: theme.typography.regular.fontSize,

    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.small.fontSize,
    },
  })
);
export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.notProvide,
}));

export const StyledBoxTabValueInform = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.orderCards,
  padding: "12px 18px",
  borderTopLeftRadius: theme.borderRadius.radius.large,
  borderTopRightRadius: theme.borderRadius.radius.large,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "5px",
  [theme.breakpoints.down("sm")]: {
    padding: "15px 20px",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "10px 15px",
  },
}));
export const StyledBoxPersonalInform = styled(Box)(({ theme }) => ({
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
  marginTop: "28px",
}));
export const StyledAddressFormContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "26px",
}));
export const StyledBoxPersonalTab = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "38px",
}));
export const StyledBoxuploadContainer = styled(Box)(() => ({
  padding: "67px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: "35px",
}));
export const StyledProfile = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems:"center",
  textAlign:"center",
  padding:"5%",
  fontWeight: "600",
  color: "#fff",
  borderRadius:"100%",
  height:'150px',
  width:'150px',
  fontSize:"100px",
  [theme.breakpoints.down("md")]: {
    fontSize:"70px",
    padding:"10%",
  },
}));
const profileFieldHeight = "48px";

export const StyledProfileFormBox = styled(Box)(({ theme }) => ({
  padding: "0px 64px",

  "& .MuiOutlinedInput-root": {
    height: profileFieldHeight,
    minHeight: profileFieldHeight,
    maxHeight: profileFieldHeight,
    borderRadius: theme.borderRadius.radius.wallet,
    backgroundColor: theme.palette.custom.white,
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-input, & .MuiInputBase-input": {
    padding: "0 10px !important",
    height: "24px",
    minHeight: "24px",
    lineHeight: "24px",
    boxSizing: "border-box",
  },
  '& input[type="date"]': {
    lineHeight: "24px",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "24px !important",
    lineHeight: "24px",
    padding: "0 10px !important",
    boxSizing: "border-box",
  },

  [theme.breakpoints.down("lg")]: {
    padding: "0px 25px",
  },
  [theme.breakpoints.down("mb")]: {
    padding: "0px 64px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0px 25px",
  },
}));
export const StyledFormActionBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "60px 0px",
}));
export const StyledBoxAddressFormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "25px",
  padding: "25px 26px",

  [theme.breakpoints.down("sm")]: {
    padding: "15px 20px",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "15px 7px",
  },
}));
export const StyledGrid = styled(Grid)(() => ({
  margin: "18px",
}));
export const StyledGridContainer = styled(Grid)(() => ({
  height: "100%",
}));
export const StyledGridLocation = styled(Grid)(() => ({
  height: "auto",
  "@media (max-width:1024px)": {
    flexBasis: "100%",
    maxWidth: "100%",
  },
}));
export const StyledProfileFieldGrid = styled(Grid)(() => ({
  "@media (max-width:1024px)": {
    flexBasis: "100%",
    maxWidth: "100%",
  },
}));
export const StyledBoxLocation = styled(Box)(() => ({
  height: "100%",
}));
export const StyledProfilePhotoContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  height:"100%",
  alignItems: "center",
  flexDirection: "column",
  gap: "32px",
}));
export const StyledProfileImage = styled(Box)(({theme})=>({
  display: "flex",
  justifyContent: "center",
  alignItems:"center",
  textAlign:"center",
  padding:"45px",
  fontSize: "48px",
  fontWeight: "600",
  color: "#fff",
  borderRadius:"100%",
  height:'150px',
  width:'150px',
  [theme.breakpoints.down("md")]: {
    fontSize: "49px",
    // padding:"10%",
  },
})) 
export const StyledGenderSelectContainer = styled(Box)(() => ({
  paddingTop: "35px",
  width: "100%",
}));
export const StyledSelectGender = styled(Select)(({ theme }) => ({
  height: profileFieldHeight,
  minHeight: profileFieldHeight,
  maxHeight: profileFieldHeight,
  borderRadius: theme.borderRadius.radius.wallet,
  backgroundColor: theme.palette.custom.white,
  boxSizing: "border-box",
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "24px !important",
    lineHeight: "24px",
    padding: "0 10px !important",
    boxSizing: "border-box",
  },
}));
export const StyledInput = styled("input")(() => ({
  display: "none",
}));
export const StyledProfileContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  padding: "20px 22px 24px",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));
export const StyledInfoGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "16px",
  flex: 1,
  width: "100%",
  minWidth: 0,
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));
export const StyledInfoCard = styled(Box)(({ theme }) => ({
  background: "#F8FAFD",
  border: "1px solid #E8EEF6",
  borderRadius: "10px",
  padding: "12px 14px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  minWidth: 0,
  overflow: "hidden",
}));
export const StyledInfoLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.profileTextUpdate,
  fontWeight: theme.typography.fontWeight.medium,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));
export const StyledInfoValue = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.profileText,
  fontWeight: theme.typography.fontWeight.semiBold,
  display: "flex",
  alignItems: "flex-start",
  flexWrap: "nowrap",
  gap: "6px",
  minWidth: 0,
  overflow: "hidden",
  "& > img, & > svg": {
    flexShrink: 0,
    marginTop: "2px",
  },
  "& .info-text": {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: 1.45,
    flex: 1,
  },
}));
export const StyledInfoName = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.large.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.profileText,
  textAlign: "center",
  marginTop: "8px",
}));
